/**
 * Lazy loaders for heavy export libraries. Module code (under `modules/`)
 * cannot resolve these packages for type-checking, so it imports them via
 * `@signals/app-shell/utils/exportLibs` instead.
 */

export const loadHtml2Canvas = async () => (await import('html2canvas')).default;

export const loadPptxGenJS = async () => {
  const mod: any = await import('pptxgenjs');
  return (mod.default ?? mod) as any;
};
